import React, { useContext } from 'react';
import { TileLayer, LayersControl } from 'react-leaflet';
import { useServerGet } from '../customEffects';
import { serverContext} from '../App';

const { BaseLayer } = LayersControl;

const MapLayersControl = (props) => {
    const { server } = useContext(serverContext);
    let baseLayerMap = localStorage.getItem("baseLayerMap");
    if (!baseLayerMap)
        baseLayerMap = "OpenStreetMap";

    const { data: mapCfg } = useServerGet('mapConfig', server);

    return (
        <LayersControl position="topright">

            {mapCfg && mapCfg.layers.map(layer => (
                <BaseLayer key={layer.title} name={layer.title} checked={baseLayerMap === layer.title}>
                    <TileLayer attribution={layer.attribution} url={layer.tileLayer} />
                </BaseLayer>
            ))}

        </LayersControl>
    );
}


export default MapLayersControl;